import {
  Button,
  Drawer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import { useNavigate } from 'react-router-dom';
import ActionButtons from '../../../../components/actionbutton';
import Filter from '../../../../assets/images/Filter.svg';
import userProfile from '../../../../assets/images/userProfile.svg';
import useDebounce from '../../../../components/Debounce';
import { Pagination } from '../../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { useHook as EquipmentsDashboard } from './useHook';
import { setGetControllerDetails } from '../../../../stores/actionTypes/controllerActions';
import { setEquipmentDetailsAction } from '../../../../stores/actionTypes/equipmentsActions';
import Popup from '../../../../components/Popup';
import { closeBlackIcon } from '../../../../assets/images';
import EquipmentFilter from './equipmentFilter';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';

interface Props {
  pagePermissionIDs: unknown;
}

const Equipments: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canCreateEquipment =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::create');
  const canDeletePermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::delete');
  const canlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::list');
  const canUpdatePermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::update');

  const canCategorylistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::list');
  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['equipments::list'] || ''}</li>
        <li>{ErrorMessage['categories::list'] || ''}</li>
      </ul>
    </section>
  );
  const { equipmentList, equipmentAllList, equipmentFilter, allCategory } =
    useSelector((state: any) => state.equipments);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 1000);
  const [totalPages, setTotalPages] = useState(1);
  const [fliterDrawerOpen, setFliterDrawerOpen] = useState(false);
  const [dealerName, setDealerName] = React.useState<string[]>([]);
  const [dealerModel, setDealerModel] = React.useState<string[]>([]);
  const [dealerCategory, setDealerCategory] = React.useState<string[]>([]);
  const [dealerSubcategory, setDealerSubcategory] = React.useState<string[]>(
    [],
  );
  const [filterEquipment, setFilterEquipment] = useState<string[]>([]);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const {
    fetchGetEquipmentList,
    fetchGetAllEquipmentList,
    fetchGetEquipmentFilter,
    handleDeleteEquipment,
    fetchGetListCategory,
  } = EquipmentsDashboard();
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteid, setDeleteid] = useState<string>('');
  const [filterDrawerData, setFilterDrawerData] = useState<any>(null);

  const handleGetEquipment = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters?: any,
    sort: { orderBy: string; order: number } = {
      orderBy: 'updatedAt',
      order: -1,
    },
  ) => {
    const payload = {
      sort: sort,
      search: search,
      filters: {
        controller: dealerName.length > 0 ? dealerName : null,
        models: dealerModel.length > 0 ? dealerModel : null,
        category: dealerCategory.length > 0 ? dealerCategory : null,
        subCategory: dealerSubcategory.length > 0 ? dealerSubcategory : null,
      },
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };
    if (canlistPermission && canCategorylistPermission) {
      await fetchGetEquipmentList(payload).then((res: any) => {
        const totalPage = res?.count
          ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
          : 1;
        setTotalPages(totalPage);
      });
    }
  };
  const handleGetAllEquipment = async () => {
    if (canlistPermission) {
      await fetchGetAllEquipmentList();
    }
  };

  useEffect(() => {
    if (!(equipmentAllList.length > 0)) {
      handleGetAllEquipment();
    }
    if (Object.keys(equipmentFilter).length === 0) {
      if (canlistPermission) {
        fetchGetEquipmentFilter();
      }
    }
    dispatch(setGetControllerDetails({}));
    dispatch(setEquipmentDetailsAction({}));
  }, [canlistPermission]);

  const handleFilterEquipment = (data: any) => {
    setFilterEquipment([
      ...data.controllerName,
      ...data.model,
      ...data.category,
      ...data.subcategory,
    ]);
    setDealerName(data.controllerName);
    setDealerModel(data.model);
    setDealerCategory(data.category);
    setDealerSubcategory(data.subcategory);
    setFliterDrawerOpen(false);
    setCurrentPage(1);
  };

  useEffect(() => {
    handleGetEquipment(currentPage, rowsPerPage, search);
    setSeeMoreIndex(filterEquipment?.length);
    setFilterDrawerData({
      controller: dealerName.length > 0 ? dealerName : [],
      models: dealerModel.length > 0 ? dealerModel : [],
      category: dealerCategory.length > 0 ? dealerCategory : [],
      subCategory: dealerSubcategory.length > 0 ? dealerSubcategory : [],
    });
  }, [filterEquipment, canlistPermission]);

  const handleRemoveFilter = (filterName: string) => {
    if (dealerName.includes(filterName)) {
      const removeData = dealerName?.filter((data) => data !== filterName);
      setDealerName(removeData);
      //rmove filterData
      const removeFilterData = filterEquipment?.filter(
        (data) => data !== filterName,
      );
      setFilterEquipment(removeFilterData);
    } else if (dealerModel.includes(filterName)) {
      const removeData = dealerModel?.filter((data) => data !== filterName);
      setDealerModel(removeData);
      //rmove filterData
      const removeFilterData = filterEquipment?.filter(
        (data) => data !== filterName,
      );
      setFilterEquipment(removeFilterData);
    } else if (dealerSubcategory.includes(filterName)) {
      const removeData = dealerSubcategory?.filter(
        (data) => data !== filterName,
      );
      setDealerSubcategory(removeData);
      //rmove filterData
      const removeFilterData = filterEquipment?.filter(
        (data) => data !== filterName,
      );
      setFilterEquipment(removeFilterData);
    } else if (dealerCategory.includes(filterName)) {
      const removeData = dealerCategory?.filter((data) => data !== filterName);
      setDealerCategory(removeData);

      // Find the subcategories to remove based on the category name
      const removedSubcategories =
        allCategory?.find(
          (category: { categoryName: string }) =>
            category.categoryName === filterName,
        )?.subCategories || [];

      // Remove subcategories from subcategoryFilter
      const removeSubCategoryData = dealerSubcategory.filter(
        (item) => !removedSubcategories.includes(item),
      );
      setDealerSubcategory(removeSubCategoryData);

      // Remove from filterData (both category and subcategory)
      const removeFilterData = filterEquipment.filter(
        (item) => !removedSubcategories.includes(item) && item !== filterName,
      );
      setFilterEquipment(removeFilterData);
    }
    // const removeData = filterEquipment?.filter((data) => data !== filterName);
    // setFilterEquipment(removeData);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    handleGetEquipment(page, rowsPerPage, search);
  };
  const handleRowsPerPageChange = (value: number) => {
    handleGetEquipment(1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (!(allCategory?.length > 0)) {
      fetchGetListCategory({});
    }
  }, []);

  useEffect(() => {
    if (debouncedSearch) {
      handleGetEquipment(1, rowsPerPage, search);
      setCurrentPage(1);
    }
  }, [debouncedSearch]);

  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    // Allow only letters, numbers, and spaces
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (regex.test(search)) {
      setSearch(search);

      if (!search) {
        handleGetEquipment(currentPage, rowsPerPage, search);
      } else {
        setCurrentPage(1);
      }
    }
  };

  const fliterOpenDrawer = () => {
    setFliterDrawerOpen(true);
  };

  const fliterCloseDrawer = () => {
    setFliterDrawerOpen(false);
  };

  const handleDeleteController = async () => {
    setCurrentPage(1);
    await handleDeleteEquipment({ equipmentID: deleteid });
    handleGetEquipment(1);
    setDeletePopup(false);
  };

  return (
    <>
      {!canlistPermission || !canCategorylistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          {deletePopup && (
            <Popup
              open={deletePopup}
              btntext="delete"
              handleClose={() => {
                setDeletePopup(false);
              }}
              handleDelete={() => {
                handleDeleteController();
              }}
              page="controller"
            />
          )}
          <div className="controller_header equipment_header flex-wrap flex-md-nowrap">
            <div>
              <ActionButtons
                image={Filter}
                title={'Filter'}
                action={fliterOpenDrawer}
                activeData={filterEquipment}
              />
              <div>
                {filterEquipment?.slice(0, seeMoreIndex).map((data, index) => (
                  <div key={index} className="filterlist">
                    <p>{data}</p>
                    <Button onClick={() => handleRemoveFilter(data)}>
                      <img src={closeBlackIcon} alt="Delete Icon" width={13} />
                    </Button>
                  </div>
                ))}
                {filterEquipment?.length > 2 && seeMoreIndex === 2 && (
                  <div className="see_more_data">
                    <Button
                      onClick={() => setSeeMoreIndex(filterEquipment?.length)}
                    >{`+${filterEquipment?.length - 2} More`}</Button>
                  </div>
                )}
                {filterEquipment?.length > 2 && seeMoreIndex !== 2 && (
                  <div className="see_more_data">
                    <Button onClick={() => setSeeMoreIndex(2)}>
                      show less
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div className="table-header-btn">
              <TextField
                variant="outlined"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: <SearchIcon />,
                }}
                className="search-input"
              />
              {canCreateEquipment && (
                <Button
                  className="create-btn create-equipment-btn"
                  color="primary"
                  onClick={() => navigate('/hardware/equipments/create')}
                >
                  Create Equipment
                </Button>
              )}
            </div>
          </div>

          <TableContainer className="controller_table" component={Paper}>
            <Table>
              <TableHead className="controller_tableheader">
                <TableRow>
                  <TableCell>Names</TableCell>
                  <TableCell>Model</TableCell>
                                   <TableCell>Controller Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Subcategory</TableCell>
                  <TableCell className="controller_tableheader_icon"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {equipmentList?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="body1" align="left">
                        No Data found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  equipmentList?.map((equipment: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>
                        <div className="controller_management_name-data">
                          <img
                            src={
                              equipment?.image ? equipment?.image : userProfile
                            }
                            width={40}
                            alt="User Profile"
                          />{' '}
                          <p>{equipment?.equipmentName}</p>
                        </div>
                      </TableCell>
                      <TableCell>
                        <p className="controller_management_model-data">
                          {equipment?.model}
                        </p>
                      </TableCell>
 <TableCell>
                        <p className="controller_management_model-data">
                          {equipment?.controllerName ? equipment?.controllerName:"-"}
                        </p>
                      </TableCell>
                      <TableCell>
                        <div className="controller_management_model-data">
                          {/* <p>{truncateText(equipment.category, 12)}</p> */}
                          <p>{equipment?.category}</p>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="controller_management_model-data">
                          <p>{equipment?.subCategory}</p>
                          {/* <p>{truncateText(equipment.subcategory, 12)}</p> */}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="form-action-btn">
                          {canUpdatePermission && (
                            <Button
                              className="btn-transparent border-0 img-background-form"
                              onClick={() =>
                                navigate(
                                  `/hardware/equipments/edit/${equipment?.equipmentName ? equipment?.equipmentName : ' '}/${equipment.equipmentID}`,
                                )
                              }
                            >
                              <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                            </Button>
                          )}
                          {canDeletePermission && (
                            <Button
                              className="btn-transparent border-0 img-background-form"
                              onClick={() => {
                                setDeleteid(
                                  equipment.equipmentID
                                    ? equipment.equipmentID
                                    : '',
                                );
                                setDeletePopup(true);
                              }}
                            >
                              <i className="delete-icon bi bi-trash3-fill bi-lg"></i>
                            </Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            rowsPerPageOptions={[5, 10, 20, 30]}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            totalPages={totalPages}
          />

          <Drawer
            open={fliterDrawerOpen}
            anchor="right"
            onClose={fliterCloseDrawer}
          >
            <EquipmentFilter
              fliterCloseDrawer={fliterCloseDrawer}
              filterSubmit={handleFilterEquipment}
              filterDrawerData={filterDrawerData}
            />
          </Drawer>
        </>
      )}
    </>
  );
};

export default Equipments;
